import React from 'react';
import {
  OndatoSuccessWrapper,
  OndatoSuccessHeader,
  OndatoSuccessSubHeader
} from './OndatoSuccess.style';
import { Trans, useTranslation } from 'react-i18next';

export const OndatoSuccess = () => {
  const { t } = useTranslation();

  return (
    <OndatoSuccessWrapper>
      <OndatoSuccessHeader>{t('ondato_success_header')}</OndatoSuccessHeader>
      <OndatoSuccessSubHeader>
        <Trans>{t('ondato_success_subheader')}</Trans>
      </OndatoSuccessSubHeader>
    </OndatoSuccessWrapper>
  );
};
